export default __webpack_public_path__ + "static/media/monica.c157bd7b.gif";